import React from "react";
import { useNavigate } from "react-router-dom";
import { isLoggedIn } from "../helpers/authHelper";

const WelcomeBanner = () => {
  const navigate = useNavigate();
  const user = isLoggedIn();

  const handleGetStarted = () => {
    if (user) {
      navigate("/posts/create");
    } else {
      navigate("/login");
    }
  };

  return (
    <div className="bg-white border rounded-2xl p-6 shadow-sm">
      
      {/* Header */}
      <h3 className="text-lg font-semibold text-gray-900">
        Welcome to ChatLog
      </h3>

      {/* Description */}
      <p className="mt-2 text-sm text-gray-600 leading-relaxed">
        A space to write, share thoughts, and have meaningful conversations.
        Follow ideas, connect with people, and explore discussions that matter.
      </p>

      {/* Action */}
      <div className="mt-4">
        <button
          onClick={handleGetStarted}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium
                     bg-gray-900 text-white hover:bg-gray-800 transition"
        >
          {user ? "Write a post" : "Get started"}
        </button>
      </div>
    </div>
  );
};

export default WelcomeBanner;
